<!--  ############### Top Select Month Start ################# -->
<div class="select_month_section">
	<section class="row">
		<div class="select_month col-auto">
			<h2><i class="bi bi-filter"></i><label for="select_year_month">{{"SelectDate" | translate}}</label> </h2>
			<select class="form-select year" aria-label="Default select example" (change)="fncCng($event, 'year')" [(ngModel)] = "selectedYear">
				<option *ngFor="let year of yearDropdown" [value]="year">
					{{year}}
				</option>
			</select>
			<select class="form-select month" aria-label="Default select example" (change)="fncCng($event, 'month')"  [(ngModel)]="selectedMonth">
				<option *ngFor="let num of monthList" value="{{num}}">{{num}}</option>
			</select>
			
		</div>
		<div class="col-auto co_name">
			<h2>{{"CompanyName" | translate}}:</h2>
			<p>{{userName}}</p>
		</div>
	</section>
</div>
<!--  ############### Top Select Month End ################# -->
<!--  ############### Middle Containt Area Start ################# -->
<div class="container_wrapper">
	

	<!-- <div class="actio_button_area">
		<span class="result_count">{{"Management.ResultCnt" | translate}}: {{totalCount}}</span>
		<button class="butn download_entry btn">{{"Home.Download" | translate}}</button>
		<button class="butn cancel_entry btn">{{"CANCEL" | translate}}</button>
	</div> -->
	<div *ngIf="dashboard_msg !== null" class="alert alert-{{msgType}} alert-dismissible" (click)="reset()" role="alert">
            {{ dashboard_msg | translate}}
			  
		<button type="button" class="close" data-dismiss="alert" aria-label="Close" style="float: right; border-radius: 15px; border: none;">
			<span aria-hidden="true">&times;</span>
			</button>
	</div>
	<!--  ############### Data Table Start ################# -->
	<div class="client_associate_list">
		<p-table 
        #dt2
        [value]="contractList" [tableStyle]="{'width':'100%'}" 
        [paginator]="true"
        [rows]="10"
        [showCurrentPageReport]="true"
        [globalFilterFields]="['sectionName', 'userName']"
        currentPageReportTemplate="{{'Showing' |translate}} {first} {{'to' | translate}} {last} {{'of' | translate}} {totalRecords} {{'entries' | translate}}"
        (onFilter)="onFilter($event)"
        (onPage)="onPage($event)">
        <!-- (onSort)="onSort()" -->
        <!-- <table class="display nowrap table table-striped" style="width:100%"> -->
            <ng-template #caption>
                
                    <p-iconfield iconPosition="left" class="ml-auto">                        
                        <label>{{"SearchByText" | translate}}:</label>
                        <input pInputText type="text" (input)="onGlobalFilter($event)" placeholder="{{'SearchKey' | translate}}" />
                    </p-iconfield>
                
            </ng-template>
            <ng-template pTemplate="header">                
				<tr class="tbl_head">					
					<th>{{"Notification.Name" | translate}}</th>
					<th>{{"Notification.Section" | translate}}</th>				
					<th>
						<div>
							<label class="switch">
								<input type="checkbox"[(ngModel)]="selectAll"
								[ngModelOptions]="{standalone: true}"
								(change)="toggleAllApprovals($event)">
								<span class="slider"></span>
							</label>
						</div>
					</th>				
				</tr>
                <!-- </thead>     -->
            </ng-template>
            <ng-template pTemplate="body" let-item>
                <tr class="tbl_cont">
                    <td 
					[attr.rtowspan]="item.section.length">{{item.userName}}</td>
                    <td>
						<p *ngFor="let sectionItem of item.section">{{sectionItem}}</p>
					</td>
					<td [attr.rtowspan]="item.section.length">
						<div class="reject_save">
							<label class="switch">
								<input type="checkbox" [(ngModel)]="item.emailNotification" (click)="emailNotification($event, item.userId)">
								<span class="slider"></span>
							</label>
						</div>
					</td>
                </tr>
            </ng-template>
            
        </p-table>
		
	</div>

	<!--  ############### Data Table End ################# -->

</div>
<!--  ############### Middle Containt Area End ################# -->